import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({providedIn: 'root'})

export class HomePageService {
    constructor(private http: HttpClient) {
    }

    numberAvailableJobsFromActivitySector(activitySector: string) {
        return this.http.get('agri/numberAvailableJobsFromActivitySector?activitySector=' + activitySector)
    }
    numberAvailableJobsFromActivitySectors(){
        return this.http.get('agri/numberAvailableJobsFromActivitySectors', {})
    }

    randomPost() {
        return this.http.get('/agri/randomPost');
    }

    // Filter Jobs
    listPublishedJobs(size, page, filterData: object) {
        return this.http.post('agri/listAllJobsFiltered?page=' + (page - 1) + '&size=' + size, filterData);
    }

    // Filter Companies
    listCompanies(size, page, filterData: object) {
        return this.http.post('agri/listAllCompaniesFiltered?page=' + (page - 1) + '&size=' + size, filterData);
    }

}
